import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

// Overlay după salvarea orelor: întreabă angajatul de pe PROIECT dacă are saci de aruncat.
export default function BagsAfterHours({ projectId, projectName, onDone }) {
  const [step, setStep] = useState("ask");
  const [fest, setFest] = useState("");
  const [schwach, setSchwach] = useState("");
  const [busy, setBusy] = useState(false);

  const totalBags = (parseInt(fest) || 0) + (parseInt(schwach) || 0);

  const save = async () => {
    if (totalBags <= 0) return toast.error("Specifică numărul de saci");
    setBusy(true);
    try {
      await api.post(`/projects/${projectId}/bags-add`, {
        festgebunden: parseInt(fest) || 0,
        schwachgebunden: parseInt(schwach) || 0,
        note: "Adăugat la pontajul zilnic",
      });
      toast.success(`🗑️ ${totalBags} saci înregistrați pe ${projectName}`);
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare la salvarea sacilor");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] bg-black/50 flex items-center justify-center p-4" data-testid="bags-after-hours-overlay">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
        {step === "ask" ? (
          <>
            <div className="text-3xl mb-2">🗑️</div>
            <div className="font-display text-lg font-extrabold mb-1">Ai saci de aruncat azi?</div>
            <div className="text-sm text-zinc-600 mb-5">
              Pe șantierul <strong>{projectName}</strong> — saci <strong>Festgebunden</strong> sau <strong>Schwachgebunden</strong>?
            </div>
            <div className="flex gap-3">
              <button
                onClick={onDone}
                className="flex-1 py-2.5 rounded-lg border border-zinc-300 font-bold text-zinc-700 hover:bg-zinc-50"
                data-testid="bags-prompt-no"
              >
                NU
              </button>
              <button
                onClick={() => setStep("counts")}
                className="flex-1 py-2.5 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-bold"
                data-testid="bags-prompt-yes"
              >
                DA, am saci
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="font-display text-lg font-extrabold mb-1">🗑️ Câți saci ai?</div>
            <div className="text-sm text-zinc-600 mb-4">Șantier: <strong>{projectName}</strong></div>
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div>
                <div className="text-xs font-bold text-amber-700 uppercase mb-1">Festgebunden</div>
                <input
                  type="number" min={0} value={fest} onChange={(e) => setFest(e.target.value)}
                  placeholder="0" autoFocus
                  className="w-full border border-zinc-300 rounded-lg px-3 py-2 text-lg font-bold"
                  data-testid="bags-prompt-fest"
                />
              </div>
              <div>
                <div className="text-xs font-bold text-red-700 uppercase mb-1">Schwachgebunden</div>
                <input
                  type="number" min={0} value={schwach} onChange={(e) => setSchwach(e.target.value)}
                  placeholder="0"
                  className="w-full border border-zinc-300 rounded-lg px-3 py-2 text-lg font-bold"
                  data-testid="bags-prompt-schwach"
                />
              </div>
            </div>
            <div className="text-center text-sm font-bold text-purple-700 mb-4">{totalBags} saci · ~{totalBags * 14} kg</div>
            <div className="flex gap-3">
              <button onClick={onDone} className="flex-1 py-2.5 rounded-lg border border-zinc-300 font-bold text-zinc-700 hover:bg-zinc-50" data-testid="bags-prompt-cancel">
                Renunță
              </button>
              <button onClick={save} disabled={busy || totalBags <= 0} className="flex-1 py-2.5 rounded-lg bg-purple-600 hover:bg-purple-700 text-white font-bold disabled:opacity-50" data-testid="bags-prompt-save">
                {busy ? "Se salvează…" : "Salvează sacii"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
